import React, { useState } from "react";
import { Accordion, Form, Button, Container, Row, Col } from "react-bootstrap";
import { TbUsersGroup, TbCopyright, TbChevronRight, TbQuestionMark, TbUser, TbPhone, TbMail, TbMessage, TbSend, TbLock } from "react-icons/tb";
import { motion } from "framer-motion";
import "./ContactUs.css";

function ClientSupport() {
  const [contactData, setContactData] = useState({
    name: "",
    phone: "",
    email: "",
    message: ""
  });

  const [supportData, setSupportData] = useState({
    name: "",
    email: "",
    subject: "",
    label: "",
    message: ""
  });

  const handleContactChange = (e) => {
    setContactData({ ...contactData, [e.target.name]: e.target.value });
  };

  const handleSupportChange = (e) => {
    setSupportData({ ...supportData, [e.target.name]: e.target.value });
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://fttunes.com/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(contactData),
      });
      if (response.ok) {
        alert("Message sent successfully!");
        setContactData({ name: "", phone: "", email: "", message: "" });
      } else {
        alert("Failed to send message.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred.");
    }
  };

  const handleSupportSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://fttunes.com/api/support", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(supportData),
      });
      if (response.ok) {
        alert("Support request sent successfully!");
        setSupportData({ name: "", email: "", subject: "", label: "", message: "" });
      } else {
        alert("Failed to send support request.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred.");
    }
  };
  return (
    <Container className="contact-main-container">
      <Row className="gx-5">
        {/* Left Column - Form */}
        <Col lg={5} className="mb-5 mb-lg-0">
          <div className="contact-form-wrapper">
            <h3>Send Us an Enquiry</h3>
            <p className="form-subtitle">Fill out the form below and our team will get back to you.</p>

            <Form className="custom-contact-form" onSubmit={handleContactSubmit}>
              <Form.Group className="mb-4" controlId="formName">
                <Form.Label><TbUser className="me-2 text-purple" />Your Name</Form.Label>
                <Form.Control type="text" name="name" value={contactData.name} onChange={handleContactChange} placeholder="Enter your full name" required />
              </Form.Group>

              <Form.Group className="mb-4" controlId="formPhone">
                <Form.Label><TbPhone className="me-2 text-purple" />Phone Number</Form.Label>
                <Form.Control type="text" name="phone" value={contactData.phone} onChange={handleContactChange} placeholder="Enter your phone number" required />
              </Form.Group>

              <Form.Group className="mb-4" controlId="formEmail">
                <Form.Label><TbMail className="me-2 text-purple" />Email Address</Form.Label>
                <Form.Control type="email" name="email" value={contactData.email} onChange={handleContactChange} placeholder="Enter your email address" required />
              </Form.Group>

              <Form.Group className="mb-4" controlId="formMessage">
                <Form.Label><TbMessage className="me-2 text-purple" />Message</Form.Label>
                <Form.Control as="textarea" name="message" value={contactData.message} onChange={handleContactChange} rows={4} placeholder="Type your message here..." required />
              </Form.Group>

              <Button type="submit" className="w-100 send-msg-btn">
                Send Message <TbSend className="ms-2" />
              </Button>
            </Form>
            
            <div className="form-footer-note">
              <TbLock className="me-1" /> Your information is safe with us. We never share your data.
            </div>
          </div>
        </Col>

        {/* Right Column - Cards & FAQ */}
        <Col lg={7}>
          <div className="contact-cards-container-new">
            <div className="contact-card active-orange">
              <div className="card-icon-container">
                <TbUsersGroup size={24} />
              </div>
              <div className="card-text-container">
                <h3>Current Clients</h3>
                <p>Access support</p>
              </div>
              <div className="card-arrow-container">
                <TbChevronRight size={20} />
              </div>
            </div>

            <div className="contact-card">
              <div className="card-icon-container">
                <TbCopyright size={24} />
              </div>
              <div className="card-text-container">
                <h3>Copyright Disputes</h3>
                <p>Report an Issue</p>
              </div>
              <div className="card-arrow-container">
                <TbChevronRight size={20} />
              </div>
            </div>
          </div>

          <div className="faq-section mt-5">
            <h4 className="faq-title mb-4">Frequently Asked Questions</h4>
            <Accordion className="contact-accordion-container">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="accordion-question-icon">
                    <TbQuestionMark size={16} />
                  </div>
                  Already a client of The FTtunes?
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    If you have account questions, please reach out to your Label
                    Manager. You can find your Label Manager contact by logging
                    into Workstation and emailing the address at the bottom of the homepage next to “Support Contact.”
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div className="accordion-question-icon">
                    <TbQuestionMark size={16} />
                  </div>
                  Having a problem logging in?
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    If you are unable to access your account, first select “Don’t
                    remember your password?” to reset your login.
                  </p>
                  <p>
                    <a id="link-login-problem" href="#" style={{textDecoration:"none", color: "#b042ff"}}>
                      Still unable to log in?
                    </a>
                  </p>
                  <p>
                    If you are still unable to login, contact us using the form
                    below:
                  </p>
                  <Form className="contact-form mt-3" onSubmit={handleSupportSubmit}>
                    <Row>
                      <Col md={6}>
                        <Form.Group controlId="formNameFAQ">
                          <Form.Label>Name</Form.Label>
                          <Form.Control type="text" name="name" value={supportData.name} onChange={handleSupportChange} placeholder="Name" required />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="formEmailFAQ">
                          <Form.Label>Email</Form.Label>
                          <Form.Control type="email" name="email" value={supportData.email} onChange={handleSupportChange} placeholder="Email" required />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="formSubjectFAQ">
                          <Form.Label>Subject</Form.Label>
                          <Form.Control type="text" name="subject" value={supportData.subject} onChange={handleSupportChange} placeholder="Subject" required />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="formLabelFAQ">
                          <Form.Label>Label</Form.Label>
                          <Form.Control type="text" name="label" value={supportData.label} onChange={handleSupportChange} placeholder="Label" required />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group controlId="formMessageFAQ">
                          <Form.Label>Message</Form.Label>
                          <Form.Control as="textarea" name="message" value={supportData.message} onChange={handleSupportChange} rows={4} placeholder="Message" required />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <Button
                          type="submit"
                          className="mt-3 submit-btn-gradient"
                        >
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default ClientSupport;
